var $c31b6134a3770ee4$exports = {};
$c31b6134a3770ee4$exports = {
    "backButton": (args)=>`Vend tilbage til ${args.prevMenuButton}`,
    "moreActions": `Flere handlinger`,
    "unavailable": `Ikke tilg\xe6ngelig, udvid for detaljer`
};


export {$c31b6134a3770ee4$exports as default};
//# sourceMappingURL=da-DK.module.js.map
